var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"download-app"},[_c('h3',[_vm._v("Download Mobile App!")]),_c('div',{staticClass:"button-row"},[_c('button',[_c('i',{staticClass:"fab fa-apple"}),_c('span',[_vm._v("App Store")])]),_c('button',[_c('i',{staticClass:"fab fa-google-play"}),_c('span',[_vm._v("Google Play")])])])])
}]

export { render, staticRenderFns }